<template>
  <div class="footer">
    <nav class="top-menu">
      <ul>
        <li v-for="(item, index) in navlist" :key="index" @click="$router.push({ path: item.path })" :class="{ 'active': $route.fullPath === item.path }">{{ item.name }}</li>
      </ul>
    </nav>

    <div class="contact-section">
      <div class="logo-container">
        <img class="footer__img logo" :src="config.bottom_logo" alt="和锦堂 Logo" />
      </div>

      <div class="contact-info">
        <div class="contact-title">联系我们</div>
        <div class="contact-item">预约电话：025-86536565</div>
        <div class="contact-item">咨询电话：025-86536562</div>
        <div class="contact-item">总部地址：南京市鼓楼区中央北路185号4楼</div>
      </div>
      <div class="qrcode-parent">
        <img src="@/assets/image/home/footer-wx.png" class="qrcode-footer__img" alt="微信公众号二维码">
        <div class="qrcode-container">
          
          <div class="qrcode">
            <img src="@/assets/image/home/footer-gzh.jpg" alt="微信公众号二维码">
            <p>扫码关注公众号</p>
          </div>
          <div class="qrcode">
            <img src="@/assets/image/home/footer-sph.jpg" alt="小程序二维码">
            <p>扫码关注视频号</p>
          </div>
        </div>
      </div>

      
    </div>
    

    <div class="copyright">
      <a href="https://beian.miit.gov.cn/" target="_blank">{{ config.record }}</a>
    </div>
  </div>
</template>

<script>
import config from '../mixin/config'
export default {
  mixins: [config],
  data () {
    return {
      navlist: [
        {
          path: '/',
          name: '关于和锦堂'
        },
        {
          path: '/Information',
          name: '和锦动态'
        },
        {
          path: '/HejinWelfare',
          name: '和锦公益'
        },
        {
          path: '/HejinSchool',
          name: '和锦学堂'
        },
        {
          path: '/RD',
          name: '研发中心'
        },
      ]
    }
  }
}
</script>

<style lang="scss" scoped>

.footer {
  margin-top: 16px;
  background-color: #fef9e7;
  .top-menu {
    font-weight: 600;
    font-size: 18px;
    text-indent: 24px;
    background-color: #fef9e7;
    padding: 10px 0;
    text-align: center;
    border-bottom: 1px solid #c9a45c;
  }

  .top-menu ul {
    display: flex;
    list-style: none;
    justify-content: center;
  }

  .top-menu li {
    margin: 0 15px;
    cursor: pointer;
  }

  .top-menu a {
    text-decoration: none;
    color: #333;
    font-size: 14px;
  }

  .contact-section {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    background-color: #fef9e7;
    padding: 8px 25%;
    border-bottom: 1px solid #e8e0c9;
  }

  .logo-container {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .logo {
    width: 240px;
  }

  .logo-text {
    font-size: 24px;
    color: #c9a45c;
    margin-top: 5px;
  }

  .contact-info {
    flex: 1;
    text-align: left;
    margin: 0 20px;
  }

  .contact-title {
    font-size: 20px;
    font-weight: bold;
    color: #c9a45c;
    margin-bottom: 15px;
    display: flex;
    align-items: center;
  }

  .contact-item {
    margin-bottom: 8px;
    font-size: 16px;
    color: #666;
  }

  .qrcode-parent {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    max-width: 360px;
    .qrcode-footer__img {
      width: 100%;
    }
  }

  .qrcode-container {
    display: flex;
    padding-top: 12px;
    justify-content: center;    
    width: 100%;
  }

  .qrcode {
    text-align: center;
    margin: 0 10px;
  }

  .qrcode img {
    width: 100px;
    height: 100px;
    border: 1px solid #e8e0c9;
  }

  .qrcode p {
    font-size: 12px;
    color: #666;
    margin-top: 5px;
  }

  .copyright {
    width: 100%;
    text-align: center;
    padding: 10px 0;
    font-size: 12px;
    background-color: #F5EAD4;
    a {
      color: #333;
    }
  }
}
@media (max-width: 768px) {
  .footer {
    .contact-section {
      padding: 10px 5%;
    }
    .logo {
      width: 120px;
    }
  }
}
@media (max-width: 1080px) {
  .footer {
    .contact-section {
      padding: 10px 5%;
    }
    .logo {
      width: 120px;
    }
    .qrcode-parent{
      max-width: 280px;
    }
  }
}
</style>